export default "__VITE_ASSET__CX26yE9r__"